import React from 'react'
import Layout from './Layout'

export default function Contact() {
  return (
    <Layout page={<div className='contact-container'>
      <h1>Contact Developer</h1>
      <form action="https://formsubmit.co/ddd21cs@cmrit.ac.in" method="POST" className='contact'>
        <input type="text" name="name" placeholder='Name' required />
        <input type="email" name="email" placeholder='E-Mail' required />
        <textarea placeholder='Message' required></textarea>
        <button type="submit">Send</button>
      </form>
    </div>} />
  )
}
